import {useJbHttpCrudService} from "../../../../../../core/service/jb-http-crud.service";
import {PartTypeEntity} from "../entity/part-type.entity";

export function usePartTypeRepository() {
  const crudService = useJbHttpCrudService<PartTypeEntity>('part-type');
  return {
    ...crudService
  }
}
